/**
 * School Search Mapping
 */
define(['jquery', 'c21', 'c21/cookie', 'c21/track', 'c21/ajax', 'c21/results', 'c21/internationalization', 'c21/charts/VerticalChart', 'jqueryinfinitescroll', 'c21minmaxdropdown'], function ($, c21, cookie, track, ajax, results, internationalization, VerticalChart) {
   "use strict";

   var schoolTooltipTopPosition = 335;

   function parseBoundaryString(strBoundary) {
      var aStrPositions = strBoundary.split("|"),
         aPoints = [];

      $.each(aStrPositions, function(i, strPosition) {
         var aLatLon = strPosition.split(","),
            iLat = parseFloat(aLatLon[1]),
            iLon = parseFloat(aLatLon[0]);

         aPoints.push([ iLat, iLon ]);
      });

      return aPoints;
   }

   function parseBoundary (strSchoolId, strHtml) {
      var jInfo = $(strHtml),
         strBoundary = jInfo.find("#schoolDetailBoundary_" + strSchoolId).val(),
         aPoints = parseBoundaryString(strBoundary);

      return aPoints;
   }

   // This file makes me want to .·´¯`(>▂<)´¯`·.
   // ~ LB
   function SchoolSearch () {
      var self = this,
         m_strModalParams = null, 
         m_iRowsPerPage = 10, 
         m_timeoutBannerHide = null, 
         m_timeoutBanner = null,
         m_sLastSchoolNameSearch = "",
         m_page;

      window.schoolSearch = self;

      // FIXME this jquery plugin is the shortest ever, but should not be here
      $.fn.reverse = [].reverse;

      self.onPageReady = function (page) {
         var jSelected = $("#selectedSchoolIds"),
            strSelectedIds = jSelected.val(),
            aSelectedIds = parseStringList(strSelectedIds);

         m_page = page;

         $(window).on({
            "refinemodalopen": closeWindow,
            "refinesizechanged": updateTooltipPosition
         });

         if (aSelectedIds.length > 0) {
            var jBounds = $("#selectedSchoolBounds"),
               aBounds = jBounds.val().split(";"),
               jLocations = $("#selectedSchoolLocations"),
               aLocations = jLocations.val().split(";"),
               aSchoolSearchItem = [];

            $.each(aSelectedIds, function(i, strSchoolId) {
               var strBounds = aBounds[i],
                  aBoundary = (strBounds === "null") ? [] : parseBoundaryString(strBounds),

                  loc = aLocations[i],
                  latLon = loc.split(","),
                  iLatitude = parseFloat(latLon[0]),
                  iLongitude = parseFloat(latLon[1]),

                  schoolSearchItem = new SchoolSearchItem(strSchoolId, iLatitude, iLongitude, aBoundary);

               aSchoolSearchItem.push(schoolSearchItem);
            });

            m_page.getMap().setInitialSelectedSchools(aSchoolSearchItem);
         }

         // Hide school refine section if draw tool is selected
         if ($("#drawTool").hasClass("selected")) {
            $(".schoolsRefine").hide();
         }

         $("#refineSearch").on("portalAjaxLoadEvent", initRefinement);
         initRefinement();

         initToolTip();
         initSchoolSearchBanner();
         showSchoolSearchBanner();

         $.uniform.update();
         
         // If the modal is already open, then don't re-initialize.
         if ($("#SchoolsModalDiv").is(":visible")) {
            openSchoolRefinement();
            if ($("#modalTopRatedSchoolsRadio").prop("checked")) {
               selectTopRatedOption();
            } else {
               selectUserSelectedOption();
            }
            $.uniform.update();
            return;
         }

         // Initialize the modal search criteria only if not already initialized.
         // Search criteria HTML is outside the body tags which get replaced on refinement.
         // NOTE: Can't use the value of the input, or the browser will save the result
         // and the modal will NOT re-initialize when the back button ends up here
         var jInitialized = $("#schoolSearchInitialized"),
            strInitialized = jInitialized.attr("initialized");
         if (strInitialized === undefined) {
            initSchoolSearchCriteria();
            $.uniform.update();
            jInitialized.attr("initialized", "Y");
         }
         
         self.initAttendanceRadiusBoundaryDialogs();
      };

      function initRefinement () {
         $(".schoolsRefine").hover(function() {
            $(this).addClass("hover");
         }, function() {
            $(this).removeClass("hover");
         });
         $(".schoolsRefine").find(
               "#topRatedSchoolsRadio, #showYourSchoolsRadio").uniform();

         // Search By Schools Button
         self.initSearchSchoolsButton();
         self.initTopRatedSchools();
         self.initYourSchools();
      }

      /**
       * Columnize programs
       * 
       */
      self.cleanPrograms = function() {
         var jFirstColumn = $("#programsFirstColumn"), jSecondColumn = $("#programsSecondColumn"), jPrograms = $(
               "#programsFirstColumn .programBox").reverse(), iTotalHeight = jFirstColumn
               .outerHeight(true), iHalfHeight = iTotalHeight / 2, iCurrentHeight = 0;

         jPrograms.each(function(i, box) {
            var jBox = $(box), iBoxHeight = jBox.outerHeight(true);

            if ((iBoxHeight + iCurrentHeight) <= iHalfHeight) {
               jBox.prependTo(jSecondColumn);
               iCurrentHeight += iBoxHeight;
            }
         });
      };

      /**
       * Add the location geocodes
       * 
       */
      self.addLocation = function(data) {
         var aSchoolSearchItem = [];

         $
               .each(
                     data.points,
                     function(i, propInfo) {
                        var iLatitude = parseFloat(propInfo[0]), iLongitude = parseFloat(propInfo[1]), strId = propInfo[2], searchItem = new SchoolSearchItem(
                              strId, iLatitude, iLongitude);

                        aSchoolSearchItem.push(searchItem);
                     });

         m_page.getMap().setSchools(aSchoolSearchItem);
      };

      /**
       * This function is called when user clicks on edit to edit the schools
       * already selected from left lane current search selections section.
       * 
       */
      self.editSchools = function() {
         // If the modal is already open, then don't re-initialize.
         if (!$("#SchoolsModalDiv").is(":visible")) {
            // Initialize to the top rated option only if no search has been
            // done before
            if (!$("#topRatedSchoolsRadio").prop("checked") &&
                  !$("#showYourSchoolsRadio").prop("checked")) {
               selectTopRatedOption();
            }
            openSchoolRefinement();
            loadSchoolDistrictModal("Y");
         }
      };

      /**
       * Remove all the user selected schools when user clicks on 'remove all'
       * from left lane current search selections section. And, do a property
       * search.
       * 
       */
      self.removeAllSchools = function(doPropSearch) {
         // Deselect all the schools
         var jSelected = $("#selectedSchoolIds"),
            aSelectedSchools = parseStringFromElement(jSelected);

         $.each(aSelectedSchools, function(i, strSchoolId) {
            $("#schoolCheckbox_" + strSchoolId).prop("checked", false);
         });

         jSelected.val("");
         $("#schoolRadiusSelector").val("1");
         $.uniform.update();

         updateMapSelectedSchools(jSelected);

         if (doPropSearch === "Y") {
            doPropertySearch();
         }
      };

      /**
       * Remove passed in user selected school when user clicks on 'remove' for
       * school from left lane current search selections section. And, do a
       * property search.
       * 
       */
      self.removeSchool = function(schoolID) {
         if (!schoolID) {
            return;
         }

         var jSelected = $("#selectedSchoolIds");
         $("#schoolCheckbox_" + schoolID).prop("checked", false);
         removeStringFromElement(jSelected, schoolID);
         updateMapSelectedSchools(jSelected);
         $.uniform.update();
         doPropertySearch();
      };

      /**
       * Re-position school tip when the current search box is size is changed
       * 
       */
      function updateTooltipPosition (o) {
         var iHeightDiff = o.heightDiff;

/*
         var topPosition = schoolTooltipTopPosition + iHeightDiff;

         $("#SchoolSearchBanner").animate({
            top : topPosition
         });
*/

         var topPosition = schoolTooltipTopPosition + iHeightDiff,
            jSchoolResults = $("#schoolSearchResults");

         if (jSchoolResults.length === 0) return;

         var iSearchListTop = jSchoolResults.position().top,
            iSearchListBottom = iSearchListTop + jSchoolResults.height(),
            jContentTip = $("#schoolsToolTip .contentTip"),
            iContentTipHeight = jContentTip.height();

         jContentTip.stop().animate({
            top: topPosition
         }, {
            step: function (iNow) {
               if (iNow > (iSearchListBottom - iContentTipHeight)) {
                  jContentTip.hide();
                  return;
               }

               if (iNow < iSearchListTop) {
                  jContentTip.hide();
                  return;
               }

               jContentTip.show();
            }
         });
      }

      /**
       * Initialize the content tool tip of the modal
       * 
       */
      function initToolTip() {
         var topPosition = schoolTooltipTopPosition +
               parseInt($(".currentSrBox").css("height")) -
               parseInt($(".currentSrBox").css("min-height"));
         $("#schoolsToolTip .contentTip").animate({
            top : topPosition
         });
      }

      /**
       * Initialize the school search refine dropdowns
       * 
       */
      function initRefineDropDowns() {
         // School Types and Grades
         $('#lqschooltypes, #lqschoolgrades').uniform({
            selectClass : 'selector smallSelector'
         });

         var bSomethingChanged = false;
         function onBlurAndChange() {
            bSomethingChanged = true;
         }

         function onGradesDropdownBlur() {
            track.doEvent('Schools', 'School Results Dialog', 'Filter by Grades'); 
            onBlur();
         }
         
         function onNoOfStudentsDropdownBlur() {
            track.doEvent('Schools', 'School Results Dialog', 'Filter by Total # of Students'); 
            onBlur();
         }
         
         function onStudentTeacherRatioDropdownBlur() {
            track.doEvent('Schools', 'School Results Dialog', 'Filter by Student/Teacher Ratio'); 
            onBlur();
         }
         
         // NOTE: Fires after onBlurAndChange
         function onBlur() {
            if (!bSomethingChanged) {
               return;
            }

            // Wait a second!
            setTimeout(function() {
               // Check if any dropdowns are showing
               var bShowing = false, jC21Dropdown = $("#lqschoolgrades");

               if(jC21Dropdown.is(":visible")) {
                  bShowing = true;
                  return false;
               }

               // If so, the user PROBABLY doesn't want to submit the search
               // quite yet!!!
               if (bShowing)
                  return;

               // Ok maybe the user does
               selectUserSelectedOption();
               loadSchoolDistrictModal("Y");
            }, 1000);
         }

         $("#lqstudents").c21minmaxdropdown({
            maxLength : 4,
            tabIndex : 804,
            onBlurAndChange : onBlurAndChange,
            onBlur : onNoOfStudentsDropdownBlur,
            dropdownClass : 'lqdropdownCustomizations',
            selectBoxClass : 'lqselectorCustomizations',
            baseName : 'lqstudents',
            selectedVal : 'max'
         });

         $("#lqstudentratio").c21minmaxdropdown({
            maxLength : 3,
            tabIndex : 806,
            onBlurAndChange : onBlurAndChange,
            onBlur : onStudentTeacherRatioDropdownBlur,
            dropdownClass : 'lqdropdownCustomizations',
            selectBoxClass : 'lqselectorCustomizations',
            baseName : 'lqstudentratio',
            selectedVal : 'max'
         });
      }

      /**
       * Initialize Attendance Radius dialog
       * 
       */
      self.initAttendanceRadiusBoundaryDialogs = function() {
         var selectedSchools = $("#selectedSchoolIds").val();
         var attendanceRadius = $("#schoolAttendanceRadius").val();
         var hasRadiusSchools = $("#hasRadiusSchools").val();

         if (selectedSchools && selectedSchools.length > 0) {
            if ((!attendanceRadius) && (hasRadiusSchools === "true")) {
               self.showRadiusSelectDialog();
               return;
            }       
            if (isSchoolOutOfBounds()) {
               showSchoolBoundaryDialog("Y");
               return;
            }
         }
      }
      ;
                  
      /**
       * Initialize the Top Rated Schools
       * 
       */
      self.initTopRatedSchools = function() {
         // School search type - Top Rated
         $("#topRatedSchoolsRadio").click(function() {
            if (!$(".schoolsRefine").hasClass("selected")) {
               $(window).trigger("refinemodalopen");
               $(".schoolsRefine").addClass("selected");
            }
            track.doEvent('Schools', 'Mapping Page', 'Show Top Rated Schools');
            $('#schoolsToolTip').addClass("openModal");
            onClickTopRatedSearchOption();
         });
      };

      function setOption (jEl, bSelected) {
         var jContainerLabel = jEl.parent().parent().parent();

         jEl.prop("checked", bSelected);

         if (bSelected) {
            jContainerLabel.addClass("selected");
         } else {
            jContainerLabel.removeClass("selected");
         }

         $.uniform.update(jEl);
      }

      /**
       * Select the top rated option
       * 
       */
      function selectTopRatedOption() {
         setOption($("#modalShowYourSchoolsRadio"), false);
         setOption($("#showYourSchoolsRadio"), false);
         setOption($("#modalTopRatedSchoolsRadio"), true);
         setOption($("#topRatedSchoolsRadio"), true);
         setSchoolNameDefault();
      }

      /**
       * Select the user selected option
       * 
       */
      function selectUserSelectedOption() {
         setOption($("#modalShowYourSchoolsRadio"), true);
         setOption($("#showYourSchoolsRadio"), true);
         setOption($("#modalTopRatedSchoolsRadio"), false);
         setOption($("#topRatedSchoolsRadio"), false);
         setSchoolNameDefault();
      }

      /**
       * Initialize the User Schools
       * 
       */
      self.initYourSchools = function() {
         // School search type - Show Your Schools
         $("#showYourSchoolsRadio").click(function() {
            if (!$(".schoolsRefine").hasClass("selected")) {
               $(window).trigger("refinemodalopen");
               $(".schoolsRefine").addClass("selected");
            }
            track.doEvent('Schools', 'Mapping Page', 'Show Your Schools');
            $('#schoolsToolTip').addClass("openModal");
            onClickUserSelectedSearchOption();
         });
      };

      /**
       * Initialize top rated option on modal
       * 
       */
      function initModalTopRatedOption() {
         // School search type - Top Rated
         $("#modalTopRatedSchoolsRadio").click(function() {
            track.doEvent('Schools', 'School Results Dialog', 'Show Top Rated Schools');  
            onClickTopRatedSearchOption();
         });
      }

      /**
       * Initialize user selected option on modal
       * 
       */
      function initModalUserSelectedOption() {
         // School search type - Show Your Schools
         $("#modalShowYourSchoolsRadio").click(function() {
            track.doEvent('Schools', 'School Results Dialog', 'Show Your Schools'); 
            onClickUserSelectedSearchOption();
         });
      }

      /**
       * Function called when the top rated search option is clicked
       * 
       */
      function onClickTopRatedSearchOption() {
         clearAllSearchCriteria();
         if (!$(".schoolsRefine").hasClass("selected")) {
            openSchoolRefinement();
         }
         loadSchoolDistrictModal("Y");
         selectTopRatedOption();
      }

      /**
       * Function called when the user selected search option is clicked
       * 
       */
      function onClickUserSelectedSearchOption() {
         clearAllSearchCriteria();
         if (!$(".schoolsRefine").hasClass("selected")) {
            openSchoolRefinement();
         }
         loadSchoolDistrictModal("Y");
         selectUserSelectedOption();
      }

      /**
       * Set default value for school name text field
       */
      function setSchoolNameDefault() {
         var schoolname = $("#schoolName").val();
         if (!schoolname) {
            $("#schoolName").val(internationalization.getString("School Name"));
            $("#schoolName").addClass("defaulttext");
            $("#schoolName").blur();
         }
      }

      /**
       * School Name default change
       * 
       */
      function schoolNameDefaultChange() {
         if ($("#schoolName").hasClass("defaulttext")) {
            $("#schoolName").val("");
            $("#schoolName").removeClass("defaulttext");
         }
      }

      function onSchoolNameChanging(event) {
         var jSchoolName = $("#schoolName"),
             sName = jSchoolName.val(),
             iLen = sName.length;

         // console.log("School name changed: [" + sName + "] [" + event.type + "]");

         if (event.type !== 'blur') {
            schoolNameDefaultChange();
         }

         if (sName && (sName !== "School Name") && (sName !== internationalization.getString("School Name"))) {
            if (iLen > 2 || iLen === 0 || iLen < m_sLastSchoolNameSearch.length) {
               selectUserSelectedOption();
               if (sName !== m_sLastSchoolNameSearch) {
                  m_sLastSchoolNameSearch = sName;
                  track.doEvent('Schools', 'School Results Dialog', 'Filter by School Name');
                  loadSchoolDistrictModal("Y");
               }
            }
         }
      }
      
      /**
       * Initialize the school name update button
       */
      function initSchoolNameUpdate() {
         var jSchoolName = $("#schoolName");
         m_sLastSchoolNameSearch = "";
         jSchoolName.click(schoolNameDefaultChange)
                    .bind('keyup blur', onSchoolNameChanging);
         setSchoolNameDefault();
      }

      /**
       * Initialize the school types
       * 
       */
      function initSchoolTypes() {
         $("#lqschooltypes").change(function() {
            track.doEvent('Schools', 'School Results Dialog', 'Filter by School Type', $('option:selected', '#lqschooltypes').index()); 
            selectUserSelectedOption();            
            loadSchoolDistrictModal("Y");
         });
      }

      /**
       * Initialize the school grade levels
       */
      function initSchoolGradeLevels() {
         $("#lqschoolgrades").change(function() {
            track.doEvent('Schools', 'School Results Dialog', 'Filter by School Grade Level', $('option:selected', '#lqschoolgrades').index());
            selectUserSelectedOption();
            loadSchoolDistrictModal("Y");
         });
      }

      /**
       * Initialize the sort types
       * 
       */
      function initSchoolSortTypes() {
         $("#schoolSortTypes").uniform();

         $("#schoolSortTypes").change(function() {
            track.doEvent('Schools', 'School Results Dialog', 'Change Sort by', $('option:selected', '#schoolSortTypes').index()); 
            loadSchoolDistrictModal("Y");
         });
      }

      /**
       * Iitialize the School Selection Area
       * 
       */
      function initSchoolSelectArea() {
         // Initialize uniform (and prevent double-initialization)
         $(".schoolCheckbox:not(.uniformInit)").uniform().addClass("uniformInit");
      }

      /**
       * Initialize the search types on the modal
       * 
       */
      function initModalSearchTypes() {
         $("#modalTopRatedSchoolsRadio, #modalShowYourSchoolsRadio").uniform();
         if ($("#topRatedSchoolsRadio").prop("checked")) {
            $("#modalTopRatedSchoolsRadio").prop("checked", true);
            $("#modalTopRatedSchoolsRadio").parent().parent().parent()
                  .addClass("selected");
         } else {
            $("#modalShowYourSchoolsRadio").prop("checked", true);
            $("#modalShowYourSchoolsRadio").parent().parent().parent()
                  .addClass("selected");
         }
         $.uniform.update();
      }

      /**
       * initialize the more search options link on modal
       * 
       */
      function initMoreSearchOptions() {
         $("#schoolsToolTip .moreSearchOptionsLink").click(
               function() {
                  if ($("#schoolsToolTip .moreSearchOptionsLink").hasClass(
                        "selected")) {
                     $("#schoolsToolTip .moreSearchOptionsLink").removeClass(
                           "selected");
                     $("#schoolsToolTip .moreSearchOptionsSection")
                           .removeClass("selected");
                     $("#schoolsToolTip .moreSearchOptionsLink").text(
                         internationalization.getString("More School Options"));
                     track.doEvent('Schools', 'School Results Dialog', 'Hide More School Options');
                  } else {
                     $("#schoolsToolTip .moreSearchOptionsLink").addClass(
                           "selected");
                     $("#schoolsToolTip .moreSearchOptionsSection").addClass(
                           "selected");
                     $("#schoolsToolTip .moreSearchOptionsLink").text(
                         internationalization.getString("Hide School Options"));
                     track.doEvent('Schools', 'School Results Dialog', 'Show More School Options');                     
                     selectUserSelectedOption();
                  }
               });

         $("#schoolsToolTip .schoolFlagCheckbox")
               .click(
                     function() {
                        track.doEvent('Schools', 'School Results Dialog', 'Filter by Refined Search Options');
                        selectUserSelectedOption();

                        var jFlags = $("#selectedSchoolFlags"),
                           //selectedFlags = jFlags.val(),
                           strElementId = $(this).attr("id"),

                           // Get the flag ID
                           flagid = strElementId.substr(11);

                        if (!$(this).prop("checked")) {
                           removeStringFromElement(jFlags, flagid);
                        } else {
                           addStringToElement(jFlags, flagid);
                        }

                        // Perform school search
                        loadSchoolDistrictModal("Y");
                     });

         $("#schoolsToolTip .schoolFlagCheckbox").uniform();
         $.uniform.update();
      }

      /**
       * Hide more search options
       * 
       */
      self.hideMoreSearchOptions = function() {
         $("#schoolsToolTip .moreSearchOptionsLink").removeClass("selected");
         $("#schoolsToolTip .moreSearchOptionsSection").removeClass("selected");
         $("#schoolsToolTip .moreSearchOptionsLink")
               .text(internationalization.getString("More School Options"));
      };

      /**
       * Remove string value from comma seperated values of element
       */
      function removeStringFromElement(jElement, strToRemove) {
         var strList = jElement.val(),
            strNewList = removeFromStringList(strList, strToRemove);

         jElement.val(strNewList);
         return strNewList;
      }

      function addStringToElement(jElement, strToAdd) {
         var strList = jElement.val(),
            strNewList = addToStringList(strList, strToAdd);

         jElement.val(strNewList);
         return strNewList;
      }

      function parseStringFromElement(jElement) {
         var strValue = jElement.val(),
            aList = parseStringList(strValue);

         return aList;
      }

      function removeFromStringList(strList, strToRemove) {
         if (strList) {
            if (strList.indexOf(strToRemove + ",") !== -1) {
               strList = strList.replace(strToRemove + ",", "");
            } else if (strList.indexOf("," + strToRemove) !== -1) {
               strList = strList.replace("," + strToRemove, "");
            } else {
               strList = strList.replace(strToRemove, "");
            }
         }
         return strList;
      }

      function addToStringList(strList, strToAdd) {
         if (!strList) {
            strList = strToAdd;
         } else {
            strList = strList + "," + strToAdd;
         }

         return strList;
      }

      function parseStringList(strList) {
         if (!strList) {
            return [];
         } else {
            return strList.split(",");
         }
      }

      function updateMapSelectedSchools(jSelected) {
         var aSelectedSchools = parseStringFromElement(jSelected);
         m_page.getMap().setSelectedSchools(aSelectedSchools);
      }

      /**
       * Initialize the user school selections
       * 
       */
      function initUserSelectedSchools() {
         // Click to view school details
         $(".viewSchoolDetailsLink").unbind(".schoolResults").bind(
               "click.schoolResults", function() {
                  var strElementId = $(this).attr("id"),

                     // Get the school ID
                     strSchoolId = strElementId.substr(22);

                  track.doEvent('Schools', 'School Results Dialog', 'View School Details');
                  self.loadSchoolDetails(strSchoolId);
               });
                  
         // Hover over school record event
         $(".schoolRecord").unbind(".schoolResults").bind(
               "mouseenter.schoolResults", function() {
                  $(this).addClass("hover");
               }).bind("mouseleave.schoolResults", function() {
            $(this).removeClass("hover");
         });

         // School selection event
         $(".schoolCheckbox")
               .unbind(".schoolResults")
               .bind(
                     "click.schoolResults",
                     function() {
                        var jSelected = $("#selectedSchoolIds"),

                           jThis = $(this),
                           strElementId = jThis.attr("id"),

                           // Get the school ID
                           strSchoolId = strElementId.substr(15);

                        $.uniform.update(jThis.get(0));

                        if (!jThis.prop("checked")) {
                           removeStringFromElement(jSelected, strSchoolId);
                           updateMapSelectedSchools(jSelected);

                           // Perform property search
                           doPropertySearch();
                        } else {
                           addStringToElement(jSelected, strSchoolId);
                           updateMapSelectedSchools(jSelected);

                           // Set the current selected school
                           $("#currSelectedSchoolID").val(strSchoolId);

                           // No additional dialog needed
                           if (!isRadiusRequired(strSchoolId) &&
                                 !isSchoolOutOfBounds(strSchoolId)) {
                              doPropertySearch();
                              return;
                           }

                           // Get the attendance radius if not already set and
                           // the school has no boundary
                           if (isRadiusRequired(strSchoolId)) {
                              self.showRadiusSelectDialog();
                              return;
                           }

                           // Get the school boundary
                           if (isSchoolOutOfBounds(strSchoolId)) {
                              showSchoolBoundaryDialog("Y");
                              return;
                           }
                        }
                     });

         // Select the user schools
         var jSelected = $("#selectedSchoolIds"),
            aSelectedSchools = parseStringFromElement(jSelected);

         $.each(aSelectedSchools, function(i, strSchoolId) {
            $("#schoolCheckbox_" + strSchoolId).prop("checked", true);
         });

         $.uniform.update();
      }

      /**
       * Is attendance radius required
       * 
       */
      function isRadiusRequired(strSchoolId) {
         var radius = $("#schoolAttendanceRadius").val();
         if (!radius &&
               $("#schoolHasBoundary_" + strSchoolId).val() === "false") {
            return true;
         }
         return false;
      }

      /**
       * Is school out of bounds with location
       * 
       */
      function isSchoolOutOfBounds(strSchoolId) {
         if ($("#schoolLocationOverride").val() === "Y" || $("#schoolLocationOverride").val() === "N") {
            return false;
         }

         if (!strSchoolId) {
            // This is called on full page load
            var showBoundDialog = $("#hasSchoolOutofBounds").val(); 
            if (showBoundDialog === "true") {
               return true;
            }
         } else {
            // this is called on school selection checkbox
            var locationOverride = $("#schoolOutOfBounds_" + strSchoolId).val();
            if (locationOverride === "true") {
               return true;
            }
         }

         return false;
      }

      /**
       * Initialize the school search banner display
       * 
       */
      function initSchoolSearchBanner() {
         $("#SchoolSearchBanner").click(function() {
            track.doEvent('Schools', 'Mapping Page', 'Click Schools Flyout'); 
            selectTopRatedOption();
            openSchoolRefinement();
            loadSchoolDistrictModal("Y");
         });

         var topPosition = schoolTooltipTopPosition +
               parseInt($(".currentSrBox").css("height")) -
               parseInt($(".currentSrBox").css("min-height"));
         $("#SchoolSearchBanner").css({
            top : topPosition
         });
      }

      /**
       * Hide the school search banner display
       * 
       */
      function hideSchoolSearchBanner() {
         // Set a cookie with last search ts
         var d = new Date(), n = d.getTime(), jBanner = $("#SchoolSearchBanner");
         cookie.set("LAST_SCHOOLSEARCH_TS", n);
         if (jBanner.is(":visible")) {
            $("#SchoolSearchBanner").animate({
               "width" : "0px"
            }, function () {
               $(this).hide();
            });
         }
      }

      /**
       * Show the school search banner display
       * 
       */
      function showSchoolSearchBanner() {
         // Show the banner if the cookie is not set
         var schoolsearchCookie = cookie.get("LAST_SCHOOLSEARCH_TS");
         if (!schoolsearchCookie) {
            clearTimeout(m_timeoutBanner);
            clearTimeout(m_timeoutBannerHide);
            m_timeoutBanner = setTimeout(function() {
               $("#SchoolSearchBanner").css("width", "0").show().animate({
                  "width" : "184px"
               });
            }, 5000);
            m_timeoutBannerHide = setTimeout(hideSchoolSearchBanner, 16000);
         }
      }

      /**
       * Show the radius selector dialog
       * 
       */
      self.showRadiusSelectDialog = function() {
         $("#SchoolModalRadiusSelect").show();
      };

      /**
       * Close the radius selector dialog
       * 
       */
      self.closeRadiusSelectDialog = function() {
         $("#SchoolModalRadiusSelect").hide();
         searchWithAttendanceRadius();
      };

      /**
       * Search with the new user selected attendance radius
       * 
       */
      function searchWithAttendanceRadius() {
         var newradius = $("#schoolRadiusSelector").val();
         $("#schoolAttendanceRadius").val(newradius);
         $("#SchoolModalRadiusSelect").hide();

         track.doEvent('Schools', 'Choose Attendance Radius Dialog', 'Select Radius', parseInt($("#schoolRadiusSelector option:selected").text()));

         var kilometers = parseInt(newradius) * 1.609344;
         m_page.getMap().setSchoolRadius(kilometers);

         var currSelectedSchoolID = $("#currSelectedSchoolID").val();
         if (isSchoolOutOfBounds(currSelectedSchoolID)) {
            // open school boundary dialog
            showSchoolBoundaryDialog("Y");
         } else {
            doPropertySearch();
         }
      }

      /**
       * Show the school boundary dialog
       * 
       */
      function showSchoolBoundaryDialog() {
         $("#SchoolModalBoundary").show();
      }

      /**
       * Close the boundary dialog
       * 
       */
      self.closeBoundarySelectDialog = function(flag) {
         if(flag === 'Y') {
            track.doEvent('Schools', 'Use School Boundaries Dialog', "Click 'Yes'");	 
         } else {
            track.doEvent('Schools', 'Use School Boundaries Dialog', "Click 'No'");
         }

         $("#SchoolModalBoundary").hide();
         searchWithSchoolBoundary(flag);
      };

      /**
       * Search with the new user boundary
       * 
       */
      function searchWithSchoolBoundary(flag) {
         $("#schoolLocationOverride").val(flag);
         $("#SchoolModalBoundary").hide();

         // Perform property search
         doPropertySearch();
      }

      /**
       * Show the school deletion dialog
       * 
       */
      self.showSchoolDeletionModal = function() {
         $("#SchoolModalDeletion").show();
      };

      /**
       * Close the school deletion dialog
       * 
       */
      self.closeDeletionSelectDialog = function(flag) {
         $("#SchoolModalDeletion").hide();
         if (flag === 'Y') {
            $("#selectedSchoolIds").val("");
            $("#schoolAttendanceRadius").val("");
            $("#schoolLocationOverride").val("");
            $("#currSelectedSchoolID").val("");

            clearAllSearchCriteria();
            closeWindow();

            if ($("#searchWithinMap").attr("checked")) {
               // Search within map
               results.changeLiquidMapSearchWithinMapFacet();
               m_page.getMap().clearSchools();
            } else if ($("#drawTool").hasClass("selected")) {
               // Drawing tool
               $(".schoolsRefine").hide();
               results.changeSchools(null, null, null);
               m_page.getMap().clearSchools();
            } else {
               // Location refine
               track.doEvent('Hybrid Mapping', 'Left Lane', 'Refine and Update Location');  
               results.changeSearchLocation($('#refineText'));
            }
         } else {
            // Un-check search within map
            if ($("#searchWithinMap").prop("checked")) {
               $("#searchWithinMap").prop("checked", false);
            } else if ($("#drawTool").hasClass("selected")) {
               $("#drawTool").removeClass("selected");
               m_page.getMap().deselectDrawingTool();
            }
         }
      };

      /**
       * Perform Property Search
       * 
       */
      function doPropertySearch() {
         var jSelected = $("#selectedSchoolIds"),
            aSelectedSchools = parseStringFromElement(jSelected),
            schoolAttendanceRadius = $("#schoolAttendanceRadius").val(),
            schoolLocationOverride = $("#schoolLocationOverride").val();

         results.changeSchools(aSelectedSchools, schoolAttendanceRadius,
               schoolLocationOverride);
      }

      /**
       * Load the school district modal
       */
      function loadSchoolDistrictModal(loadGeocodes) {
         hideSchoolSearchBanner();

         var m_map = m_page.getMap(), aParams = ajax
               .getParameters();

         if (!loadGeocodes) {
            loadGeocodes = "N";
         }

         var schoolName = $("#schoolName").val();
         if ((!schoolName) || schoolName === "School Name" || schoolName === internationalization.getString("School Name")) {
            schoolName = "";
         }

         var schoolSortType = $("#schoolSortTypes").val();
         if (!schoolSortType) {
            schoolSortType = "";
         }

         var schoolType = $("#lqschooltypes").val();
         if (!schoolType) {
            schoolType = "";
         }

         var schoolgrade = $("#lqschoolgrades").val();
         if (!schoolgrade) {
            schoolgrade = "";
         }

         // Number of students
         var studentsmin = $("#lqstudentsFrom").val(), studentsmax = $(
               "#lqstudentsTo").val(), studentcount = "";
         if (studentsmin && studentsmax) {
            studentcount = studentsmin + c21.GS2 + studentsmax;
         } else if (studentsmin) {
            studentcount = studentsmin + c21.GS2;
         } else if (studentsmax) {
            studentcount = "0" + c21.GS2 + studentsmax;
         }

         // Student Ratio
         var ratiomin = $("#lqstudentratioFrom").val(), ratiomax = $(
               "#lqstudentratioTo").val(), studentratio = "";
         if (ratiomin && ratiomax) {
            studentratio = ratiomin + c21.GS2 + ratiomax;
         } else if (ratiomin) {
            studentratio = ratiomin + c21.GS2;
         } else if (ratiomax) {
            studentratio = "0" + c21.GS2 + ratiomax;
         }

         // Get the selected schools
         var selectedSchools = $("#selectedSchoolIds").val();
         if (!selectedSchools) {
            selectedSchools = "";
         }

         // Get the selected flags
         var selectedflags = $("#selectedSchoolFlags").val();
         if (!selectedflags) {
            selectedflags = "";
         }

         // Get the search type
         var searchType = "";
         if ($("#showYourSchoolsRadio").prop("checked")) {
            searchType = "UserSelected";
         } else {
            searchType = "TopRated";
         }

         // Get the attendance radius
         var radius = $("#schoolAttendanceRadius").val();
         if (!radius) {
            radius = "";
         }

         // Location override
         var locoverride = $("#schoolLocationOverride").val();
         if (!locoverride) {
            locoverride = "";
         }

         // Get the search locations (main location and surrounding areas)
         var searchLocations = "",
            strLids = $("#searchLocationLIDS").val();

         if (strLids) {
            searchLocations = strLids;
            if (aParams.lid && (searchLocations !== aParams.lid)) {
               if (searchLocations.indexOf(aParams.lid + ",") === -1) {
                  searchLocations = searchLocations + "," + aParams.lid;
               }
            }
         } else {
            searchLocations = aParams.lid; 
         }
         
         m_strModalParams = $.param({
            lid : searchLocations,
            schoolname : schoolName,
            sortby : schoolSortType,
            schooltype : schoolType,
            zoom : m_map.getZoom(),
            px : results.getMapBoundaries(),
            rpp : m_iRowsPerPage,
            grade : schoolgrade,
            flags : selectedflags,
            selectedschoolids : selectedSchools,
            searchtype : searchType,
            schoolattendanceradius : radius,
            schoollocationoverride : locoverride,
            numstudents : studentcount,
            studentratio : studentratio,
            submitted : true
         }) + '&start=';

         // Perform Search AJAX
         ajax.doViewEngineAjax('loadschooldistrictmodal',
               "/schoolsearch/results", m_strModalParams + '0&geo=' + loadGeocodes,
               {
                  cache : true,
                  callback : function() {
                     initializeModal();
                     initializeInfiniteScroll();
                     initResultPinIconScroll();
                  }
               });
      }

      function initResultPinIconScroll() {
         checkResultPinIconScroll();
         $("#schoolSearchResults").scroll(function() {
            checkResultPinIconScroll();
         });
      }

      function checkResultPinIconScroll() {
         var jContent = $("#schoolSearchResults"),
            jRecords = jContent.find(".schoolRecord"),
            aPinsInView = [];

         if (jRecords.length > 0) {
            var iRecordHeight = jRecords.eq(0).outerHeight(),

               // Menu at the top that offsets the scroll
               iMoreOptionsHeight = 20,

               // Container Scroll
               iContentTopRaw = jContent.scrollTop() - iMoreOptionsHeight,
               iContentTop = (iContentTopRaw < 0) ? 0 : iContentTopRaw,

               // Height of the container
               iContentHeight = jContent.height(),

               // The first record
               iStartRecord = Math.floor(iContentTop / iRecordHeight),

               // How much of the top record can the user see?
               iRecordTop = iContentTop % iRecordHeight,

               // How many records can the user see?
               iRecordsInView = Math.floor(iContentHeight / iRecordHeight) + 
                  ((iRecordTop > 40) ? 2 : 1),

               jRecordsInView = jRecords.splice(iStartRecord, iRecordsInView);

            $.each(jRecordsInView, function(i, el) {
               var jRecord = $(el),
                  jSchoolId = jRecord.find("input.schoolID"),
                  strSchoolId = jSchoolId.val();

               aPinsInView.push(strSchoolId);
            });
         }

         m_page.getMap().setSchoolsInView(aPinsInView);
      }

      /**
       * Look at number of results and return whether this is a full page
       */
      function isFullPage(jParent) {
         var jContainer = (jParent) ? jParent : $("#schoolSearchResults"),
            iRecords = jContainer.find(".schoolRecord").length;

         if (iRecords === 0) {
            return false;
         } else {
            return ((iRecords % m_iRowsPerPage) === 0);
         }
      }

      function showLoadingMore() {
         $("#schoolSearchResults").append(
               "<div id='loadingMore'>Loading...</div>");
      }

      function hideLoadingMore() {
         $("#loadingMore").remove();
      }

      function initializeInfiniteScroll() {
         if (!isFullPage())
            return;

         var jContent = $("#schoolSearchResults").infinitescroll({
            triggerAt : 300,
            page : 1,
            dataHandler : function(infiniteScroll) {
               showLoadingMore();
               $.ajax({
                  url : "/schoolsearch/results",
                  data : m_strModalParams + (infiniteScroll.page * m_iRowsPerPage).toString() + "&subView=loadschooldistrictmodal",

                  dataType : "json",
                  success : function(data) {
                     // Must use a <div />, because sometimes
                     // data.window comes back as
                     // an empty string, and Sizzle.js doesn't like
                     // that
                     var jResults = $("<div />").html(data[0].html);
                     jContent.append(jResults);

                     hideLoadingMore();

                     $("#noSchoolResults").hide();

                     if (!isFullPage(jResults)) {
                        infiniteScroll.setReachedEnd();
                     } else {
                        infiniteScroll.reset();
                     }

                     initializeModalPage();
                     m_page.getMap()
                           .updateSchoolHoverState();
                     checkResultPinIconScroll();
                  }
               });
            }
         });
      }

      /**
       * Initialize the school search criteria
       * 
       */
      function initSchoolSearchCriteria() {
         initSchoolSortTypes();
         initRefineDropDowns();
         initSchoolTypes();
         initSchoolGradeLevels();
         initSchoolNameUpdate();
         initModalSearchTypes();
         initModalTopRatedOption();
         initModalUserSelectedOption();
         initMoreSearchOptions();

         $.uniform.update();
      }

      /**
       * Initialize the Modal
       * 
       */
      function initializeModal() {
         var jWindow = $("#schoolsToolTip"),
             jOuter = $("#SchoolsModalDiv"),
             iWidth;

         // FIXME
         if (jWindow.data('open') === undefined) {
            jWindow.data('open', true).css("width", "");
            jOuter.show();
            iWidth = jWindow.outerWidth();
            jWindow.width(0).animate({
               width: iWidth
            }, {
               duration: 500,
               easing: 'easeInOutBack'
            });
         }

         initializeModalPage();
         m_page.getMap().showUnselectedSchools();
      }

      /**
       * Initialize a page in the Modal
       */
      function initializeModalPage() {
         initSchoolSelectArea();
         initUserSelectedSchools();

         // Initialize uniform (and prevent double-initialization)
         $(".schoolCheckbox:not(.uniformInit)").uniform().addClass(
               "uniformInit");
         $.uniform.update();
      }

      /**
       * Close Modal
       */
      self.closeWindow = function() {
         closeWindow();
      };

      /**
       * Clear the property search params
       * 
       */
      self.clearPropertySearchParams = function() {
         $("#selectedSchoolIds").val("");
         $("#schoolAttendanceRadius").val("");
         $("#schoolLocationOverride").val("");
      };

      /**
       * Close the School search modal
       * 
       */
      function closeWindow() {
         var jWindow = $("#schoolsToolTip"),
             jOuter = $("#SchoolsModalDiv");

         if (jWindow.data('open') === undefined) {
            return;
         }

         jWindow.removeData('open');
         jWindow.animate({
            width: 0
         }, {
            duration: 500,
            easing: 'easeInOutBack',
            complete: function() {
               jOuter.hide();
            }
         });

         $(".schoolsRefine").removeClass("selected");
         setOption($("#topRatedSchoolsRadio"), false);
         setOption($("#showYourSchoolsRadio"), false);
         m_page.getMap().hideUnselectedSchools();
      }

      /**
       * Clear all the search criteria
       * 
       */
      self.clearSchoolSearchCriteria = function() {
         clearAllSearchCriteria();
      };

      /**
       * Clear all the search criteria
       * 
       */
      function clearAllSearchCriteria() {
         $("#schoolName").val("");
         $(".schoolFlagCheckbox").prop("checked", false);
         $("#selectedSchoolFlags").val("");

         // Clear all the search filter drop down values
         $("#lqschooltypes").val("");
         $("#schoolSortTypes").val("");
         $("#lqschoolgrades").val('');

         $("#lqstudents").val("");
         $("#lqstudentsFrom").val("");
         $("#lqstudentsTo").val("");
         $("#lqstudents").c21minmaxdropdown("setValue", '', '');

         $("#lqstudentratio").val("");
         $("#lqstudentratioFrom").val("");
         $("#lqstudentratioTo").val("");
         $("#lqstudentratio").c21minmaxdropdown("setValue", '', '');
      }

      /**
       * Open the school refinement section
       * 
       */
      function openSchoolRefinement() {
         $(".schoolsRefine").addClass("selected");
         $.uniform.update();
      }

      /**
       * Initialize search schools button
       * 
       */
      self.initSearchSchoolsButton = function() {
         if($("#SchoolsModalDiv").is(":visible")) {
            // school search modal visible already - school refinement
            $(".schoolsRefine").addClass("selected");
            if($("#modalTopRatedSchoolsRadio").prop("checked")) {
               selectTopRatedOption();
            } else if($("#modalShowYourSchoolsRadio").prop("checked")) {
               selectUserSelectedOption();
            }
         }

         $("#schoolsLiqMapButton").hover(function() {
            $(this).addClass("hover");
         }, function() {
            $(this).removeClass("hover");
         });
         $("#schoolsLiqMapButton").click(
               function() {
                  if (!$(".schoolsRefine").hasClass("selected")) {
                     // Initialize to the top rated option only if no search has
                     // been done before
                     if (!$("#topRatedSchoolsRadio").prop("checked") && !$("#showYourSchoolsRadio").prop("checked")) {
                        selectTopRatedOption();
                     }

                     // FIXME: Use jQuery events to do this
                     //window.surroundingAreasMapping.closeWindow();
                     $(window).trigger("refinemodalopen");

                     openSchoolRefinement();
                     loadSchoolDistrictModal("Y");
                     track.doEvent('Schools', 'Mapping Page', 'Search by Schools');
                     $(".schoolsRefine").addClass("selected");
                  } else {
                     closeWindow();
                  }
               });
      };

      /**
       * Load the school details
       * 
       */
      self.loadSchoolDetails = function(schoolID) {
         var m_map = m_page.getMap();

         // Perform Detail AJAX
         ajax.doViewEngineAjax('loadschooldetails', "/schoolsearch/detail",
               $.param({
                  sid : schoolID,
                  zoom : m_map.getZoom(),
                  px : results.getMapBoundaries(),
                  submitted : true
               }), {
                  cache : true,
                  callback : function() {
                     initializeSchoolDetailsModal();
                  }
               });

      };

      /**
       * Show the school detail information
       * 
       */
      function initializeSchoolDetailsModal() {
         $("#schoolSearchResults").hide();
         $("#searchTabsSection").hide();
         $(".searchCriteriaDiv").hide();
         $("#schoolDetailInformation").show();

         // Hide the programs tab if there are no programs
         var totalPrograms = $("#totalSchoolPrograms").val();
         if (totalPrograms && totalPrograms <= 0) {
            $("#schoolDetailsDiv .programsTab").hide();
            $("#schoolDetailsDiv .programstabHeader").hide();
            $("#schoolDetailsDiv .programstabHeader").removeClass("selected");
         }

         // Default to the overview tab
         if (!$("#schoolDetailsDiv .overviewtabHeader").hasClass("selected")) {
            $("#schoolDetailsDiv .overviewtabHeader").addClass("selected");
         }
         showOverviewTab();

         $("#schoolDetailsDiv .overviewtabHeader").click(function() {
            if (!$(this).hasClass("selected")) {
               $(this).addClass("selected");
            }            
            track.doEvent('Schools', 'School Details Dialog', 'Show Overview Tab'); 
            showOverviewTab();
         });
         $("#schoolDetailsDiv .programstabHeader").click(function() {
            if (!$(this).hasClass("selected")) {
               $(this).addClass("selected");
            }
            track.doEvent('Schools', 'School Details Dialog', 'Show Programs Tab');
            showProgramsTab();
         });

         // Hover states
         $("#schoolDetailsDiv .overviewtabHeader").hover(function() {
            $(this).addClass("hover");
         }, function() {
            $(this).removeClass("hover");
         });
         $("#schoolDetailsDiv .programstabHeader").hover(function() {
            $(this).addClass("hover");
         }, function() {
            $(this).removeClass("hover");
         });
      }

      /**
       * Show the search results
       * 
       */
      self.showSearchResults = function() {
         $("#schoolSearchResults").show();
         $("#searchTabsSection").show();
         $(".searchCriteriaDiv").show();

         $("#schoolDetailInformation").hide();
         $("#programsTabAccessed").val("");
      };

      function showOverviewTab() {
         $("#schoolDetailsDiv .overviewTab").show();
         $("#schoolDetailsDiv .overviewtabHeader").addClass("selected");
         $("#schoolDetailsDiv .programsTab").hide();
         $("#schoolDetailsDiv .programstabHeader").removeClass("selected");
      }

      self.showOverviewTab = function() {
         showOverviewTab();
      };
      
      function showProgramsTab() {
         $("#schoolDetailsDiv .overviewTab").hide();
         $("#schoolDetailsDiv .programsTab").show();
         $("#schoolDetailsDiv .programstabHeader").addClass("selected");
         $("#schoolDetailsDiv .overviewtabHeader").removeClass("selected");

         // Programs Tab columnizer
         var programsTabAccessed = $("#programsTabAccessed").val();
         if (programsTabAccessed === "") {
            $("#programsTabAccessed").val("Y");
            self.cleanPrograms();
         }
      }

      /**
       * A school search result
       * @param strId
       * @param iLatitude
       * @param iLongitude
       * @param [aBoundary] (optional)
       */
      var SchoolSearchItem = function(strId, iLatitude, iLongitude, aBoundary) {
         var self = this,
            m_strId = strId,
            m_iLatitude = iLatitude,
            m_iLongitude = iLongitude,
            m_aBoundary = aBoundary;

         self.getId = function() {
            return m_strId;
         };

         self.getLatitude = function() {
            return m_iLatitude;
         };

         self.getLongitude = function() {
            return m_iLongitude;
         };

         self.getBoundary = function() {
            return m_aBoundary;
         };
      };

      self.parseBoundary = parseBoundary;
   }

   // Static method
   SchoolSearch.parseBoundary = parseBoundary;

   return SchoolSearch;
});
